// JSON-LD (schema.org) builders. Each returns a plain node WITHOUT @context;
// the Seo component wraps a list of these into a single @graph document.

import { SITE, absoluteUrl } from '../config/site';

export function organizationSchema() {
  return {
    '@type': 'Organization',
    '@id': `${SITE.url}/#organization`,
    name: SITE.name,
    url: SITE.url,
    logo: absoluteUrl(SITE.logo),
  };
}

export function websiteSchema() {
  return {
    '@type': 'WebSite',
    '@id': `${SITE.url}/#website`,
    name: SITE.name,
    url: SITE.url,
    description: SITE.description,
    publisher: { '@id': `${SITE.url}/#organization` },
  };
}

// items: [{ name, path }] ordered root -> current
export function breadcrumbSchema(items) {
  return {
    '@type': 'BreadcrumbList',
    itemListElement: items.map((item, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      name: item.name,
      item: absoluteUrl(item.path),
    })),
  };
}

// Builds a SportsEvent from a public match record.
export function sportsEventSchema({ match, canonicalPath }) {
  const teams = [match.team_1_name, match.team_2_name].filter(Boolean);
  const startDate =
    match.date && match.time ? `${match.date}T${match.time}` : match.date || undefined;

  const schema = {
    '@type': 'SportsEvent',
    name: teams.length === 2 ? `${teams[0]} vs ${teams[1]}` : 'Rocket League Match',
    sport: 'Rocket League',
    url: absoluteUrl(canonicalPath),
  };

  if (startDate) schema.startDate = startDate;
  if (match.league) schema.organizer = { '@type': 'Organization', name: match.league };
  if (teams.length) {
    schema.competitor = teams.map((name) => ({ '@type': 'SportsTeam', name }));
  }
  // schema.org has no "completed" status; only flag scheduled/live events.
  if (match.match_status && match.match_status !== 'completed') {
    schema.eventStatus = 'https://schema.org/EventScheduled';
  }

  return schema;
}
